// src/pages/Login.js
import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../auth';


// Samme stil som ab-admin's login: hvidt kort med tynd kant på hvid baggrund.
const GREEN = '#00B861';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: #ffffff;
`;

const LoginBox = styled.div`
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  padding: 32px;
  width: 100%;
  max-width: 400px;
`;

const Logo = styled.div`
  margin-bottom: 24px;

  img {
    height: 32px;
    display: block;
  }
`;

const Title = styled.h1`
  color: #171717;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #E5E5E5;
  border-radius: 12px;
  background: #ffffff;
  color: #000000;
  font-size: 14px;
  transition: box-shadow 0.2s, border-color 0.2s;

  &::placeholder {
    color: #A3A3A3;
  }

  &:focus {
    outline: none;
    border-color: ${GREEN};
    box-shadow: 0 0 0 2px ${GREEN};
  }
`;

const Button = styled.button`
  background: ${GREEN};
  color: white;
  border: none;
  min-height: 52px;
  padding: 0 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #008f4c;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

const ErrorMessage = styled.p`
  color: #EF4444;
  margin-top: 16px;
  font-size: 14px;
  text-align: center;
`;

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, login } = useAuth();

  const from = location.state?.from?.pathname || '/calculator';

  if (user) return <Navigate to={from} replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError('Indtast venligst e-mail og adgangskode');
      return;
    }

    setSubmitting(true);
    setError('');
    try {
      await login(username, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login fejlede. Prøv igen.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Logo>
          <img src="/Autobasen_logo.svg" alt="Autobasen Logo" />
        </Logo>
        <Title>Log ind på ABBeregner</Title>
        <Form onSubmit={handleSubmit}>
          <Input 
            type="email" 
            autoComplete="username"
            placeholder="E-mail"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input 
            type="password" 
            autoComplete="current-password"
            placeholder="Adgangskode"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" disabled={submitting}>{submitting ? 'Logger ind…' : 'Log ind'}</Button>
        </Form>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </LoginBox>
    </LoginContainer>
  );
}

export default Login;
